import { render } from "./WhatWeOffer.vue?vue&type=template&id=4dabf9ef"
import script from "./WhatWeOffer.vue?vue&type=script&lang=js"
export * from "./WhatWeOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__